/* @ngInject */
function ApprovalListItemController ($scope, $translate, $element, $timeout, $q, UdsModalService, TasksService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/subtask-details/subtask-details-dialog.controller'))

  const api = {
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController,
    _initTooltip,
    _openSubtaskDetailsDialog,
    _openRequestDetailsDialog,
    _updateApprovalListContent
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._initTooltip()
  }

  $scope.openTaskDetailDialog = (task) => {
    if (task.originType === 'SUBTASK') {
      TasksService.getTaskById(task.id).then(subtask => {
        api._openSubtaskDetailsDialog(subtask)
      })
    } else {
      api._openRequestDetailsDialog(task.id)
    }
  }

  $scope.isDeadlineOverdue = (deadline, status) => {
    return new Date(deadline).getTime() < new Date().getTime() && status === 'PENDING'
  }

  $scope.getTaskIcon = (task) => {
    if (task.originType === 'TASK') return 'tasks'

    if (task.originType === 'SUBTASK') return 'subtask'

    return task.author?.role === 'USER' ? 'workflow' : 'clipboard'
  }

  $scope.getDateTooltip = (translationToken, date) => {
    const text = $translate.instant(translationToken)

    const momentDate = moment(date)
    const formattedDate = momentDate.format('L')
    const hour = momentDate.format('HH:mm')

    return `${text}: ${formattedDate} - ${hour}`
  }

  function _initTooltip () {
    $timeout(() => {
      angular.element($element).find('.approval-list-item .tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 250, false)
  }

  function _openSubtaskDetailsDialog (subtask) {
    api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: SubtaskDetailsDialogController,
        modalName: 'subtaskDetailsDialog',
        data: {
          subtask
        },
        onClose: (data) => {
          api._updateApprovalListContent(data)
        }
      })
      modal.open()
    })
  }

  function _openRequestDetailsDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: (data) => {
          api._updateApprovalListContent(data)
        }
      })
      modal.open()
    })
  }

  function _updateApprovalListContent ({ updatedFields, wasUpdated }) {
    if (updatedFields?.title?.updated) {
      $scope.approval.task.title = updatedFields.title.newValue
    }
    if (updatedFields?.priority?.updated) {
      $scope.approval.task.priority = updatedFields.priority.newValue
    }
    if (updatedFields?.status?.updated) {
      $scope.approval.task.status = updatedFields.status.newValue
    }
    if (wasUpdated) {
      $scope.lastRefreshedAt = new Date().getTime()
    }
    if (updatedFields?.internalApproval?.updated) {
      $scope.$emit('workflow.home.reloadApprovalsTab')
    }
  }
}

export { ApprovalListItemController }
